import React from 'react';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import * as ds from './dataService';

export type SaveCommentFormProps = {
  id: string;
  taskId?: string;
  handleClose: () => void;
};

export const FC = (props: SaveCommentFormProps) => {
  const [
    fnSaveForm,
    { loading }
  ] = ds.useSaveComment();
  const form = ds.useFormState(props.id, props.taskId ?? '');

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await fnSaveForm({
          ...form.formState
        });
        props.handleClose();
      }}
      isLoading={loading}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <StyledTextField.FC
        {...form.genFieldProps('description')}
        multiline
        minRows={4}
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
